import { app } from '../../../app';

app.factory('DeviceManagement', DeviceManagement);

/** @ngInject */
function DeviceManagement($resource) {
    return $resource('app/rest/device_management/:id', {}, {
        'query' : {
            method : 'GET',
            isArray : true
        },
        'get' : {
            method : 'GET'
        }
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/user/device-management/device-management.service.js